import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../shared/user.service';
import { Subscription } from 'rxjs';
import { User } from '../shared/user.model';
import { DataService } from '../shared/data.service';
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  user: User;
  userSubscription = new Subscription();
  constructor(private dataService: DataService, private userService: UserService) { }

  mysite() {
    window.open('https://my.ppai.org/', '_blank');
  }
  refresh() {
    window.location.href = '/';
  }
  logout() {
    window.location.href = 'https://login.ppai.org/logout.aspx';
  }
  feedback() {
    $('#feedbackModal').modal('show');
  }
  credit() {
    var url: string;
    this.dataService.getCreditReportUrl("GeneralServices", null).subscribe((response) => {
      url = response;
      window.open(url, '_blank');
    });

  }
  ngOnInit() {
this.userSubscription = this.userService.userChanged.subscribe(
  (user: User) => {
    this.user = user;
  }
)
  }
  ngOnDestroy(){
    this.userSubscription.unsubscribe();
  }

}
